import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import NpsFilters from './NpsFilters';
import NpsRow from './NpsRow';
import PaginationFooter from '../../components/PaginationFooter';

const HEADERS = [
  { label: 'Nota', align: 'left' },
  { label: 'Comentários', align: 'left' },
  { label: 'Usuário', align: 'left' },
  { label: 'Empresa', align: 'left' },
  { label: 'Tela', align: 'left' },
  { label: 'Status', align: 'left' },
  { label: 'Data', align: 'left' },
  { label: 'Ações', align: 'right' },
];

/**
 * NpsTable - Tabela da aba "Avaliações (NPS)" com filtros e paginação server-side (Admin Geral)
 * @param {Object} props
 * @param {Array} props.nps
 * @param {boolean} props.isLoading
 * @param {string|null} props.error
 * @param {Object} props.pagination
 * @param {Object} props.filters - props repassadas ao NpsFilters
 * @param {Function} props.onPageChange
 * @param {Function} props.onView
 */
function NpsTable({
  nps = [],
  isLoading = false,
  error = null,
  pagination,
  filters,
  onPageChange,
  onView,
}) {
  return (
    <Paper
      sx={{
        borderRadius: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        border: '1px solid #E8ECF0',
        overflow: 'hidden',
      }}
    >
      <NpsFilters {...filters} />

      {error && (
        <Alert severity="error" sx={{ borderRadius: 0 }}>
          {error}
        </Alert>
      )}

      <TableContainer sx={{ boxShadow: 'none', borderRadius: 0 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#F8F9FC' }}>
              {HEADERS.map((h) => (
                <TableCell
                  key={h.label}
                  align={h.align}
                  sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.8125rem', whiteSpace: 'nowrap' }}
                >
                  {h.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                  <CircularProgress size={32} />
                </TableCell>
              </TableRow>
            ) : nps.length === 0 ? (
              <TableRow>
                <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                  <Typography variant="body2" color="text.secondary">
                    Nenhum feedback encontrado
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              nps.map((item) => (
                <NpsRow key={item.id} item={item} onView={onView} />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <PaginationFooter pagination={pagination} onPageChange={onPageChange} itemLabel="avaliações" />
    </Paper>
  );
}

export default NpsTable;
